import { useState } from "react";
import { useUser } from "@/app/context/UserContext";
export default function NotificationForm() {
  const { userProject, setUserProject } = useUser();

  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [link, setLink] = useState("");
  const [expiresAt, setExpiresAt] = useState("");

  const notifications = userProject.project.notifications || [];

  const handleAddNotification = () => {
    if (!title || !body || !expiresAt) {
      alert("Completa todos los campos obligatorios");
      return;
    }

    const newNotification = {
      title,
      body,
      link,
      expiration_date: new Date(expiresAt).toISOString(),
      read: false,
    };
    setUserProject({
      ...userProject,
      project: { 
        ...userProject.project, 
        notifications: [...(userProject.project.notifications || []), newNotification],
        
      },
    });
    setTitle("");
    setBody("");
    setLink("");
    setExpiresAt("");
  };

  const handleDelete = (indexToDelete: number) => {
    setUserProject((prev:any) => {
      const currentNotifs = prev.project?.notifications || [];
      const updatedNotifs = currentNotifs.filter((_:any, i:number) => i !== indexToDelete);

      return {
        ...prev,
        project: {
          ...prev.project,
          notifications: updatedNotifs,
        },
      };
    });
  };

  return (
    <div className="w-full max-w-2xl mx-auto mt-8 space-y-6">
      <div className="p-6 border border-gray-300 bg-white rounded-3xl shadow-md">
        <h3 className="text-lg font-bold mb-4 text-gray-700">➕ Agregar Notificación</h3>

        <div className="space-y-4">
          <div>
            <label className="block font-medium text-gray-700">Título *</label>
            <input
              type="text"
              className="w-full border border-gray-300 rounded-xl px-3 py-2 text-gray-800"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>

          <div>
            <label className="block font-medium text-gray-700">Mensaje *</label>
            <textarea
              className="w-full border border-gray-300 rounded-xl px-3 py-2 text-gray-800"
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />
          </div>

          <div>
            <label className="block font-medium text-gray-700">Link (opcional)</label>
            <input
              type="text"
              className="w-full border border-gray-300 rounded-xl px-3 py-2 text-gray-800"
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
          </div>

          <div>
            <label className="block font-medium text-gray-700">Fecha de Expiración *</label>
            <input
              type="date"
              className="w-full border border-gray-300 rounded-xl px-3 py-2 text-gray-800"
              value={expiresAt}
              onChange={(e) => setExpiresAt(e.target.value)}
            />
          </div>

          <button
            onClick={handleAddNotification}
            className="bg-gray-100 border border-gray-300 text-gray-700 px-4 py-2 rounded-xl hover:bg-gray-200 transition"
          >
            Guardar Notificación
          </button>
        </div>
      </div>

      <div className="mt-8">
        <h3 className="text-lg font-bold mb-4 text-gray-700">🔔 Notificaciones actuales</h3>

        {notifications.length === 0 ? (
          <p className="text-sm italic text-gray-500">No hay notificaciones registradas.</p>
        ) : (
          <div className="space-y-4">
            {notifications.map((notif, index) => (
              <div
                key={index}
                className="border border-gray-300 bg-gray-50 p-4 rounded-2xl shadow-sm relative"
              >
                <div className="absolute top-2 right-2">
                  <button
                    onClick={() => handleDelete(index)}
                    className="text-red-500 hover:text-red-700 text-sm font-bold"
                    title="Eliminar"
                  >
                    ❌
                  </button>
                </div>

                <h4 className="text-sm font-bold text-center mb-1 text-gray-700">
                  {notif.title}
                </h4>
                <p className="text-sm italic text-center text-gray-600">{notif.body}</p>

                {notif.link && (
                  <div className="flex justify-center mt-2">
                    <a
                      href={notif.link}
                      target="_blank"
                      className="text-sm text-blue-600 underline hover:text-blue-800"
                      rel="noopener noreferrer"
                    >
                      🔗 Ver enlace
                    </a>
                  </div>
                )}

                {notif.expiration_date && (
                  <p className="text-xs text-center mt-2 text-gray-500">
                    Expira: {new Date(notif.expiration_date).toLocaleDateString()}
                  </p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
